// extracted by mini-css-extract-plugin
export default {"redirect":"redirect_redirect__lFHF8","spinner":"redirect_spinner__Yj0q8","loadingText":"redirect_loadingText__7KpHk"};